export class GuideClass {
  static UNDEFINED = -1;
  static BEHAVIOUR = 0;
  static EDUCATION = 1;
  static RELATIONS = 2;
}
